import { FC, ElementType, forwardRef } from "react";
import { StyledHeading } from "./style";
import { ColorProps, SpaceProps, TypographyProps } from "../../../shared/styled";

interface IProps extends SpaceProps, ColorProps, TypographyProps {
    as?: ElementType;
    className?: string;
    tt?: string;
}

const Heading: FC<IProps> = forwardRef(
    ({ as, className, tt, children, ...restProps }, ref) => {
        return (
            <StyledHeading
                as={as}
                className={className}
                $tt={tt}
                ref={ref}
                {...restProps}
            >
                {children}
            </StyledHeading>
        );
    }
);

Heading.displayName = "Heading";

export default Heading;
